<template>
  <div class="failed-payment-banner">
    <div class="qrw-label-lg bold qrw-text-content-base-inverse-primary">
      {{$t('failed_payment_banner.text')}}
    </div>

    <BasePushButton
      @click="$router.push('/superbilling')"
      variant="primary"
      size="xs"
      bgColor="background-base-inverse-primary"
      textColor="content-base-inverse-primary"
    >
      {{$t('failed_payment_banner.btn')}}
    </BasePushButton>
  </div>
</template>

<script>
export default {}
</script>

<style scoped>
.failed-payment-banner {
  padding: 10px 16px;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  background: var(--qrw-background-warning-default);
  width: 100%;
}
</style>